import { createStore } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import modal from './modules/modal'
import tempTask from './modules/tempTask'
import { baseRouterList, routerList } from '@/router'
import { vhostInfo } from '@/api/home'

export default createStore({
  state: {
    menuList: [],
    hostInfo: {},
    host: {},
  },
  mutations: {
    // 获取主机、状态、配置等信息
    setMainInfo(state, payload) {
      state.hostInfo = payload
    },
    setHost(state, payload) {
      state.host = payload
    },
    getMenuList(state, payload) {
      const newList = Xinnet.util.getMenuRouterList?.(
        cloneDeep(baseRouterList.concat(payload.list || routerList))
      )
      const menus: any = Xinnet.util.getPermissionMenus?.(newList, payload.role)
      state.menuList = menus || []
    },
  },
  actions: {
    // 获取主机信息
    async getHostInfo({ commit }) {
      const res: any = await vhostInfo()
      const data = res?.res || {}
      commit('setHost', data)
      return data
    }
  },
  modules: {
    modal,
    tempTask,
  }
})
